import React from 'react';

import * as S from './styles';
import Divider from '../../../../../components/common/Divider';
import { ButtonSimple } from '../../../../../components/newStudent/Buttons';
import { PrintOutlined } from '@mui/icons-material';
import { formatDateHour } from '../../../../../util/common/appUtil';
import { IInternalTicketDetail } from '../../../../../interfaces/newStudent/ticket.interface';
import { getHistoricMovementNumber } from '../../../../../util/newStudent/ticket/historicMovementNumber';

interface Props {
  ticket: IInternalTicketDetail;
}

export default function TicketDescription({ ticket }: Props) {
  const totalHistoric = ticket.historic.length;

  return (
    <S.Container>
      {ticket.historic.map((historicItem, index) => (
        <S.KeyValueItem key={historicItem.id}>
          <S.MovementHeaderRow>
            <S.Key>
              Movimentação n°
              {getHistoricMovementNumber(totalHistoric, index)} incluída por{' '}
              {historicItem.userName ?? 'Usuário'} no dia{' '}
              {formatDateHour(historicItem.createdDate)}
            </S.Key>
            {historicItem.attachments &&
              historicItem.attachments.length > 0 && (
                <S.AttachmentsEnd>
                  {historicItem.attachments.map((attachment) => (
                    <S.DivAnexos key={attachment.id}>
                      <S.AttachmentName>{attachment.filename}</S.AttachmentName>
                      <ButtonSimple
                        color="success"
                        heightSize="small"
                        widthSize="small"
                        onClick={() => window.open(attachment.url)}
                      >
                        <PrintOutlined fontSize="large" />
                      </ButtonSimple>
                    </S.DivAnexos>
                  ))}
                </S.AttachmentsEnd>
              )}
          </S.MovementHeaderRow>
          <div
            dangerouslySetInnerHTML={{ __html: historicItem.description }}
            style={{ wordBreak: 'break-word' }}
          />
          <Divider color="gray02" />
        </S.KeyValueItem>
      ))}
    </S.Container>
  );
}
